import React from "react";
import EmbryoLogo from "../assets/embryo-removebg.png";

const Footer = () => {
  return (
    <footer className="w-full mt-auto py-3 bg-black/40 backdrop-blur border-t border-white/10">
      <div className="max-w-5xl mx-auto flex items-center justify-center px-4">
        <div className="flex items-center gap-2">
          <span className="text-xs uppercase tracking-[0.15em] text-slate-200/70 font-medium">
            Powered By
          </span>
          <img
            src={EmbryoLogo}
            alt="SLT Digital Lab Logo"
            className="h-7 w-auto opacity-90 hover:opacity-100 transition"
          />
        </div>
        <div />
      </div>
    </footer>
  );
};

export default Footer;

